// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import CircularProgress from "@mui/material/CircularProgress";
// import { styled } from "@mui/material/styles";
// import Collapse from "@mui/material/Collapse";
// import IconButton from "@mui/material/IconButton";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import Button from "@mui/material/Button";
// import TextField from "@mui/material/TextField";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";

// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import { useUserContext } from "context/UserContext";

// // ================== TreeNode styles ==================
// const TreeNode = styled(Box)(({ theme, level = 0 }) => ({
//   display: "flex",
//   flexDirection: "column",
//   marginLeft: level * 16,
//   paddingLeft: 8,
//   borderLeft: "1px dashed",
//   borderColor: theme.palette.divider,
// }));

// const TreeNodeHeader = styled(Box)({
//   display: "flex",
//   alignItems: "center",
//   padding: "4px 0",
//   cursor: "pointer",
//   "&:hover": {
//     backgroundColor: "rgba(0, 0, 0, 0.04)",
//   },
// });

// // ================== WalletInfo ==================
// const WalletInfo = ({ wallet }) => {
//   if (!wallet) return null;
//   return (
//     <Box sx={{ ml: 2, mt: 1, p: 1, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
//       <Typography variant="body2">
//         <strong>Balance:</strong> {wallet.lsBalance} {wallet.lsCurrency}
//       </Typography>
//     </Box>
//   );
// };
// WalletInfo.propTypes = { wallet: PropTypes.object };

// // ================== Recursive Tree ==================
// const ThirdPartyTreeNode = ({ node, level = 0 }) => {
//   const [expanded, setExpanded] = useState(level < 2);

//   return (
//     <TreeNode level={level}>
//       <TreeNodeHeader onClick={() => setExpanded(!expanded)}>
//         <IconButton size="small" sx={{ mr: 1 }}>
//           {node.Children && node.Children.length > 0 ? (
//             expanded ? (
//               <ExpandMoreIcon fontSize="small" />
//             ) : (
//               <ChevronRightIcon fontSize="small" />
//             )
//           ) : null}
//         </IconButton>
//         <Box>
//           <Typography component="span" variant="body2" sx={{ fontWeight: level < 2 ? 500 : 400 }}>
//             {node.TierLabel ? `[${node.TierLabel}] ` : ""}
//             {node.Name}
//           </Typography>
//           {node.NameAlias && (
//             <Typography variant="caption" color="textSecondary" display="block">
//               {node.NameAlias}
//             </Typography>
//           )}
//         </Box>
//       </TreeNodeHeader>

//       <Collapse in={expanded}>
//         {node.Wallet && <WalletInfo wallet={node.Wallet} />}
//         {node.Children?.map((child) => (
//           <ThirdPartyTreeNode key={child.ID} node={child} level={level + 1} />
//         ))}
//       </Collapse>
//     </TreeNode>
//   );
// };
// ThirdPartyTreeNode.propTypes = {
//   node: PropTypes.object.isRequired,
//   level: PropTypes.number,
// };

// // ================== Main Page ==================
// function ManufacturerBK() {
//   const { userData, role } = useUserContext() || {};
//   const hierarchyDataRef = React.useRef(null);
//   const [flatNodes, setFlatNodes] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [reloadFlag, setReloadFlag] = useState(0);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [formData, setFormData] = useState({
//     name: "",
//     email: userData?.email,
//     parent: "",
//     tier_level: "",
//     client_email: "",
//     ref: "",
//     phone: "",
//     address: "",
//   });

//   const TIER_MAP = {
//     1: "GA層級",
//     2: "LA層級",
//     3: "Brand層級",
//     4: "Store層級",
//     5: "機器層級",
//     6: "機器上下倉層級",
//   };

//   const buildHierarchy = (items, parentId = null) => {
//     const parentIdStr = String(parentId || "");
//     return (items || [])
//       .filter((item) => String(item.parent || "") === parentIdStr)
//       .map((item) => ({
//         ID: item.id,
//         Name: item.name,
//         NameAlias: item.raw?.note_private || null,
//         Parent: item.parent || "",
//         Wallet: null,
//         Tier: item.tier,
//         TierLabel: TIER_MAP[item.tier] || "Unknown",
//         Children: buildHierarchy(items, item.id),
//       }));
//   };

//   const flattenHierarchy = (node) => {
//     let nodes = [{ ID: node.ID, Name: node.Name, Tier: node.Tier, TierLabel: node.TierLabel }];
//     node.Children?.forEach((child) => {
//       nodes = nodes.concat(flattenHierarchy(child));
//     });
//     return nodes;
//   };

//   // ---------- Fetch hierarchy ----------
//   useEffect(() => {
//     const fetchAndProcessHierarchy = async () => {
//       if (!userData?.email) {
//         setError("Email is required to fetch hierarchy data");
//         setIsLoading(false);
//         return;
//       }
//       setIsLoading(true);
//       setError(null);

//       try {
//         const apiUrl = `https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/mdm/tierlevel?email=${encodeURIComponent(
//           userData.email
//         )}`;
//         const mdmAuthToken = "57b2a9ba-4428-48e4-b137-f8337b68595e";

//         const response = await fetch(apiUrl, {
//           method: "GET",
//           headers: { "Mdm-Auth": mdmAuthToken },
//         });

//         if (!response.ok) throw new Error(`Server responded with status: ${response.status}`);
//         const result = await response.json();
//         if (result.code !== 200) throw new Error(result.message || "Error fetching hierarchy data");

//         const apiData = result.data;
//         if (!apiData || !apiData.root) throw new Error("No hierarchy data or root node found");

//         const allThirdParties = [
//           ...(apiData.ga || []),
//           ...(apiData.la || []),
//           ...(apiData.brand || []),
//           ...(apiData.shop || []),
//           ...(apiData.machine || []),
//           ...(apiData.machine_group || []),
//         ];

//         const root = apiData.root;
//         hierarchyDataRef.current = {
//           Username: root.name,
//           MatchedNode: {
//             ID: root.id,
//             Name: root.name,
//             NameAlias: root.raw?.note_private || null,
//             Parent: root.parent || "",
//             Wallet: null,
//             Tier: root.tier,
//             TierLabel: TIER_MAP[root.tier],
//             Children: buildHierarchy(allThirdParties, root.id),
//           },
//         };

//         setFlatNodes(flattenHierarchy(hierarchyDataRef.current.MatchedNode));
//       } catch (err) {
//         console.error("Error processing hierarchy:", err);
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (userData?.email) fetchAndProcessHierarchy();
//   }, [userData?.email, reloadFlag]); // ✅ 加上 reloadFlag 依賴

//   const hierarchyData = hierarchyDataRef.current;

//   // ---------- Form ----------
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "parent") {
//       const parentNode = flatNodes.find((n) => n.ID === value);
//       setFormData((prev) => ({
//         ...prev,
//         parent: value,
//         tier_level: parentNode ? String(parentNode.Tier + 1) : String(prev.tier_level),
//       }));
//     } else if (name === "tier_level") {
//       setFormData((prev) => ({
//         ...prev,
//         tier_level: String(value),
//         parent: flatNodes.find((n) => n.ID === prev.parent && n.Tier === Number(value) - 1)
//           ? prev.parent
//           : "",
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       if (!formData.name.trim()) {
//         alert("名稱必填");
//         return;
//       }
//       if (!formData.tier_level) {
//         alert("層級必填");
//         return;
//       }
//       if (!formData.parent) {
//         alert("父節點必填");
//         return;
//       }

//       const apiUrl =
//         "https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/mdm/thirdparty/create";
//       const mdmAuthToken = "57b2a9ba-4428-48e4-b137-f8337b68595e";

//       const payload = {
//         ...formData,
//         parent: parseInt(formData.parent, 10),
//       };

//       const res = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Mdm-Auth": mdmAuthToken,
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await res.json();
//       if (result.code !== 200) throw new Error(result.message || "Create failed");

//       // 成功後關閉 Dialog 並刷新 hierarchy
//       setOpenDialog(false);
//       setFormData({
//         name: "",
//         email: userData?.email,
//         parent: "",
//         tier_level: "",
//         client_email: "",
//         ref: "",
//         phone: "",
//         address: "",
//       });

//       setReloadFlag((f) => f + 1); // ✅ 觸發刷新
//     } catch (err) {
//       alert("錯誤: " + err.message);
//     }
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//               >
//                 <MDTypography variant="h6" color="white">
//                   {role === "SP" ? "Manufacturer" : "廠商"}
//                 </MDTypography>
//                 <Button
//                   variant="contained"
//                   onClick={() => setOpenDialog(true)}
//                   sx={{
//                     backgroundColor: "#FF9800",
//                     color: "#FFFFFF",
//                     "&:hover": { backgroundColor: "#FB8C00" },
//                   }}
//                 >
//                   創建廠商
//                 </Button>
//               </MDBox>
//               <MDBox p={3}>
//                 {isLoading ? (
//                   <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
//                     <CircularProgress />
//                   </Box>
//                 ) : error ? (
//                   <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
//                     <Typography color="error">{error}</Typography>
//                   </Box>
//                 ) : !hierarchyData?.MatchedNode ? (
//                   <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
//                     <Typography>No hierarchy data found</Typography>
//                   </Box>
//                 ) : (
//                   <Box sx={{ maxHeight: "70vh", overflow: "auto", p: 1 }}>
//                     <ThirdPartyTreeNode node={hierarchyData.MatchedNode} />
//                   </Box>
//                 )}
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>

//       {/* ===== Create Dialog ===== */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>創建廠商</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="名稱"
//             name="name"
//             fullWidth
//             margin="normal"
//             required
//             value={formData.name}
//             onChange={handleChange}
//           />
//           <TextField
//             select
//             label="層級"
//             name="tier_level"
//             fullWidth
//             margin="normal"
//             required
//             value={formData.tier_level}
//             onChange={handleChange}
//             SelectProps={{ native: true }}
//           >
//             <option value=""></option>
//             {Object.entries(TIER_MAP)
//               .filter(([key]) => Number(key) === 2 || Number(key) === 3)
//               .map(([key, label]) => (
//                 <option key={key} value={key}>
//                   {label}
//                 </option>
//               ))}
//           </TextField>
//           <TextField
//             select
//             label="父節點"
//             name="parent"
//             fullWidth
//             margin="normal"
//             required
//             value={formData.parent}
//             onChange={handleChange}
//             SelectProps={{ native: true }}
//           >
//             <option value=""></option>
//             {flatNodes
//               .filter((n) => n.Tier === Number(formData.tier_level) - 1)
//               .map((node) => (
//                 <option key={node.ID} value={node.ID}>
//                   {node.Name} [{node.TierLabel}]
//                 </option>
//               ))}
//           </TextField>
//           <TextField
//             label="客戶信箱"
//             name="client_email"
//             fullWidth
//             margin="normal"
//             value={formData.client_email}
//             onChange={handleChange}
//           />
//           <TextField
//             label="識別碼"
//             name="ref"
//             fullWidth
//             margin="normal"
//             value={formData.ref}
//             onChange={handleChange}
//           />
//           <TextField
//             label="手機"
//             name="phone"
//             fullWidth
//             margin="normal"
//             value={formData.phone}
//             onChange={handleChange}
//           />
//           <TextField
//             label="地址"
//             name="address"
//             fullWidth
//             margin="normal"
//             value={formData.address}
//             onChange={handleChange}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDialog(false)}>取消</Button>
//           <Button
//             onClick={handleSubmit}
//             sx={{ mt: 2, mb: 2, color: "white !important" }}
//             variant="contained"
//             disabled={!formData.name.trim() || !formData.tier_level || !formData.parent}
//           >
//             送出
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </DashboardLayout>
//   );
// }

// export default ManufacturerBK;

import React, { useState, useEffect } from "react";

// MUI components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useUserContext } from "context/UserContext";
import { useTranslation } from "react-i18next";
import { isBkLikeRole } from "utils/roleUtils";

function Manufacturer() {
  const { userData, role } = useUserContext() || {};
  const { t } = useTranslation("common");
  const [flatNodes, setFlatNodes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadFlag, setReloadFlag] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: userData?.email ?? "",
    parent: "",
    tier_level: "",
    client_email: "",
    ref: "",
    phone: "",
    address: "",
    company_name: "",
    u_b_c: "",
    transaction_currency: "",
    company_owner: "",
  });

  const TIER_MAP = {
    1: "GA層級",
    2: "LA層級",
    3: "Brand層級",
    4: "Store層級",
    5: "機器層級",
    6: "機器上下倉層級",
  };

  const parseMaybeJSON = (value) => {
    if (typeof value !== "string") return value;
    try {
      return JSON.parse(value);
    } catch (err) {
      console.warn("Failed to parse hierarchy field", err);
      return value;
    }
  };

  const normalizeArrayField = (value) => {
    const parsed = parseMaybeJSON(value);
    return Array.isArray(parsed) ? parsed : [];
  };

  // Build hierarchy (same as original)
  const buildHierarchy = (items, parentId = null) => {
    const parentIdStr = String(parentId || "");
    return (items || [])
      .filter((item) => String(item.parent || "") === parentIdStr)
      .map((item) => ({
        ID: item.id,
        Name: item.name,
        NameAlias: item.raw?.note_private || null,
        Parent: item.parent || "",
        Wallet: null,
        Tier: item.tier,
        TierLabel: TIER_MAP[item.tier] || "Unknown",
        Children: buildHierarchy(items, item.id),
      }));
  };

  // Flatten hierarchy for parent dropdown
  const flattenHierarchy = (node) => {
    let nodes = [{ ID: node.ID, Name: node.Name, Tier: node.Tier, TierLabel: node.TierLabel }];
    node.Children?.forEach((child) => {
      nodes = nodes.concat(flattenHierarchy(child));
    });
    return nodes;
  };

  // Fetch hierarchy data
  useEffect(() => {
    const fetchAndProcessHierarchy = async () => {
      if (!userData?.email) {
        setError("Email is required to fetch hierarchy data");
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      setError(null);

      try {
        const apiUrl = `https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/mdm/tierlevel?email=${encodeURIComponent(
          userData.email
        )}`;
        const mdmAuthToken = "57b2a9ba-4428-48e4-b137-f8337b68595e";

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: { "Mdm-Auth": mdmAuthToken },
        });

        if (!response.ok) throw new Error(`Server responded with status: ${response.status}`);
        const result = await response.json();
        if (result.code !== 200) throw new Error(result.message || "Error fetching hierarchy data");

        const apiData = parseMaybeJSON(result.data) || {};
        const rootCandidate = parseMaybeJSON(apiData.root);
        const ga = normalizeArrayField(apiData.ga);
        const la = normalizeArrayField(apiData.la);
        const brand = normalizeArrayField(apiData.brand);
        const shop = normalizeArrayField(apiData.shop);
        const machine = normalizeArrayField(apiData.machine);
        const machineGroup = normalizeArrayField(apiData.machine_group);

        const allThirdParties = [...ga, ...la, ...brand, ...shop, ...machine, ...machineGroup];
        const nodesById = new Map(
          allThirdParties.map((node) => [String(node?.id ?? node?.ref ?? ""), node])
        );

        let root = typeof rootCandidate === "object" ? rootCandidate : null;
        if (!root) {
          root = allThirdParties.find((node) => {
            const parentValue = node?.parent;
            if (!parentValue || parentValue === "0" || parentValue === 0) return true;
            return !nodesById.has(String(parentValue));
          });
        }

        if (!root) throw new Error("No hierarchy data or root node found");
        const hierarchyData = {
          Username: root.name,
          MatchedNode: {
            ID: root.id,
            Name: root.name,
            NameAlias: root.raw?.note_private || null,
            Parent: root.parent || "",
            Wallet: null,
            Tier: root.tier,
            TierLabel: TIER_MAP[root.tier],
            Children: buildHierarchy(allThirdParties, root.id),
          },
        };

        setFlatNodes(flattenHierarchy(hierarchyData.MatchedNode));
      } catch (err) {
        console.error("Error processing hierarchy:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (userData?.email) fetchAndProcessHierarchy();
  }, [userData?.email, reloadFlag, role]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "parent") {
      const parentNode = flatNodes.find((n) => n.ID === value);
      setFormData((prev) => ({
        ...prev,
        parent: value,
        tier_level: parentNode ? String(parentNode.Tier + 1) : String(prev.tier_level),
      }));
    } else if (name === "tier_level") {
      setFormData((prev) => ({
        ...prev,
        tier_level: String(value),
        parent: flatNodes.find((n) => n.ID === prev.parent && n.Tier === Number(value) - 1)
          ? prev.parent
          : "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      if (!formData.name.trim()) {
        alert("名稱必填");
        return;
      }
      if (!formData.tier_level) {
        alert("層級必填");
        return;
      }
      if (!formData.parent) {
        alert("父節點必填");
        return;
      }
      if (!formData.company_name.trim()) {
        alert("公司名稱必填");
        return;
      }
      if (!formData.u_b_c.trim()) {
        alert("統一編號必填");
        return;
      }
      if (!formData.transaction_currency.trim()) {
        alert("交易幣別必填");
        return;
      }
      if (!formData.company_owner.trim()) {
        alert("公司負責人必填");
        return;
      }

      const apiUrl =
        "https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/mdm/thirdparty/create";
      const mdmAuthToken = "57b2a9ba-4428-48e4-b137-f8337b68595e";

      const { company_name, u_b_c, transaction_currency, company_owner, ...rest } = formData;
      const trimmedCompanyName = company_name.trim();
      const trimmedUBC = u_b_c.trim();
      const trimmedTransactionCurrency = transaction_currency.trim();
      const trimmedCompanyOwner = company_owner.trim();

      const payload = {
        ...rest,
        parent: parseInt(rest.parent, 10),
        array_options: {
          options_tier_level: String(rest.tier_level || ""),
          options_company_name: trimmedCompanyName,
          options_u_b_c: trimmedUBC,
          options_transaction_currency: trimmedTransactionCurrency,
          options_company_owner: trimmedCompanyOwner,
        },
      };

      const res = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Mdm-Auth": mdmAuthToken,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      if (result.code !== 200) throw new Error(result.message || "Create failed");

      // Success: Close dialog, reset form, and trigger refresh
      setOpenDialog(false);
      setFormData({
        name: "",
        email: userData?.email ?? "",
        parent: "",
        tier_level: "",
        client_email: "",
        ref: "",
        phone: "",
        address: "",
        company_name: "",
        u_b_c: "",
        transaction_currency: "",
        company_owner: "",
      });
      setReloadFlag((f) => f + 1); // Trigger hierarchy refresh
    } catch (err) {
      alert("錯誤: " + err.message);
    }
  };

  // URL for iframe (regenerate on reloadFlag change to refresh iframe)
  const normalizedRole = isBkLikeRole(role) ? "BK" : role;
  const url = `https://app.appsmith.com/app/manufacturer/page1-68cf7913e5a05937313e7ebb?email=${encodeURIComponent(
    userData?.email ?? ""
  )}&role=${normalizedRole}&embed=true&hide_navigation_bar=true&reload=${reloadFlag}`;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {t("pageTitles.manufacturer")}
                </MDTypography>
                <Button
                  variant="contained"
                  onClick={() => setOpenDialog(true)}
                  sx={{
                    backgroundColor: "#FF9800",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#FB8C00" },
                  }}
                >
                  {t("actions.createManufacturer")}
                </Button>
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                {isLoading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="300px"
                  >
                    <CircularProgress />
                  </MDBox>
                ) : (
                  <>
                    {error && (
                      <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minHeight="80px"
                      >
                        <Typography color="error">{error}</Typography>
                      </MDBox>
                    )}
                    <iframe
                      src={url}
                      width="100%"
                      height="800px"
                      frameBorder="0"
                      title="Appsmith Embed"
                    />
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Create Manufacturer Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{t("actions.createManufacturer")}</DialogTitle>
        <DialogContent>
          <TextField
            label="名稱"
            name="name"
            fullWidth
            margin="normal"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <TextField
            select
            label="層級"
            name="tier_level"
            fullWidth
            margin="normal"
            required
            value={formData.tier_level}
            onChange={handleChange}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {Object.entries(TIER_MAP)
              .filter(([key]) => Number(key) === 2 || Number(key) === 3)
              .map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
          </TextField>
          <TextField
            select
            label="父節點"
            name="parent"
            fullWidth
            margin="normal"
            required
            value={formData.parent}
            onChange={handleChange}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {flatNodes
              .filter((n) => n.Tier === Number(formData.tier_level) - 1)
              .map((node) => (
                <option key={node.ID} value={node.ID}>
                  {node.Name} [{node.TierLabel}]
                </option>
              ))}
          </TextField>
          <TextField
            label="客戶信箱"
            name="client_email"
            fullWidth
            margin="normal"
            value={formData.client_email}
            onChange={handleChange}
          />
          <TextField
            label="識別碼"
            name="ref"
            fullWidth
            margin="normal"
            value={formData.ref}
            onChange={handleChange}
          />
          <TextField
            label="手機"
            name="phone"
            fullWidth
            margin="normal"
            value={formData.phone}
            onChange={handleChange}
          />
          <TextField
            label="地址"
            name="address"
            fullWidth
            margin="normal"
            value={formData.address}
            onChange={handleChange}
          />
          <TextField
            label="公司名稱"
            name="company_name"
            fullWidth
            margin="normal"
            required
            value={formData.company_name}
            onChange={handleChange}
          />
          <TextField
            label="統一編號"
            name="u_b_c"
            fullWidth
            margin="normal"
            required
            value={formData.u_b_c}
            onChange={handleChange}
          />
          <TextField
            label="交易幣別"
            name="transaction_currency"
            fullWidth
            margin="normal"
            required
            value={formData.transaction_currency}
            onChange={handleChange}
          />
          <TextField
            label="公司負責人"
            name="company_owner"
            fullWidth
            margin="normal"
            required
            value={formData.company_owner}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>取消</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ color: "white !important" }}
            disabled={
              !formData.name.trim() ||
              !formData.tier_level ||
              !formData.parent ||
              !formData.company_name.trim() ||
              !formData.u_b_c.trim() ||
              !formData.transaction_currency.trim() ||
              !formData.company_owner.trim()
            }
          >
            送出
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Manufacturer;
